import React, { VFC } from 'react';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Box, Container, Divider, Grid, makeStyles, Theme } from '@dxb-web-ui-framework/design-system';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { ErrorAlert } from '@dxb-web-ui-framework/common/components/ErrorAlert/ErrorAlert';
import { PayrollDetails } from '../../domain/Payroll/entities/types';
import { PayrollDetailsDrawerTable } from './PayrollDetailsDrawerTable';
import { GenericPayrollInformation } from './GenericPayrollInformation';

const useStyles = makeStyles<Theme>(({ spacing, breakpoints }) => ({
  leftContainer: {
    backgroundColor: '#F0F0F0',
    [breakpoints.down('sm')]: {
      backgroundColor: 'inherit',
    },
  },
  rightContainer: {
    maxWidth: '100%',
    flex: 1,
  },
}));

export interface PayrollDetailsContentContentProps {
  payrollDetails: Nullable<PayrollDetails>;
  isLoading: boolean;
  error: AxiosError<APIGatewayResponse<any>, any> | undefined;
}

const PayrollDetailsContent: VFC<PayrollDetailsContentContentProps> = ({ payrollDetails, isLoading, error }) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  const classes = useStyles();

  return (
    <>
      <Grid container style={{ height: '100%' }}>
        {!isEmpty(error) && (
          <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
            <ErrorAlert message={error?.message} />
          </Box>
        )}

        {isEmpty(error) && (
          <Grid item xs={isMobile ? 12 : 4}>
            <Container maxWidth={false} style={{ height: '100%' }} className={classes.leftContainer}>
              <Box ml={!isMobile ? 0 : 1} mr={1} pb={4}>
                <GenericPayrollInformation isLoading={isLoading} payrollDetails={payrollDetails} />
              </Box>
            </Container>
          </Grid>
        )}

        {!isMobile && isEmpty(error) && <Divider orientation='vertical' flexItem />}

        {payrollDetails && isEmpty(error) && (
          <Grid
            container
            item
            xs={isMobile ? 12 : 7}
            justifyContent='center'
            alignContent='flex-start'
            className={classes.rightContainer}>
            <Box py={4} px={2} width={'100%'}>
              <PayrollDetailsDrawerTable
                payrollFilesDetailsList={payrollDetails?.payrollFileDetailsList}
                isLoading={isLoading}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export { PayrollDetailsContent };
